interface cbInfo {
  lever: number
}
interface cbReturnInfo {
  command: "return" | "continue" | "void"
}
/**
 * 树的遍历方法
 * @param tree 树
 * @param cb 回调函数，参数为item和cbInfo,如果返回了终端指令（command）就会终端执行
 * @param executeCbWhen 回调函数执行时机（递归前or递归后）
 */
export function eachTree<T>(
  tree: T[],
  cb: (item: T, info: cbInfo) => cbReturnInfo | void,
  executeCbWhen: "beforeEach" | "afterEach" = "afterEach",
) {
  function each(arr: T[], lever) {
    for (const item of arr) {
      let cbReturnInfo: cbReturnInfo | void
      if (executeCbWhen === "beforeEach") {
        cbReturnInfo = cb(item, { lever })
        if (cbReturnInfo?.command === "return") return cbReturnInfo
        if (cbReturnInfo?.command === "continue") continue
      }
      const len = (item as any).children?.length ?? 0
      if (len > 0) {
        cbReturnInfo = each((item as any).children!, lever + 1)
        if (cbReturnInfo?.command === "return") return cbReturnInfo
        if (cbReturnInfo?.command === "continue") continue
      }
      if (executeCbWhen === "afterEach") {
        cbReturnInfo = cb(item, { lever })
        if (cbReturnInfo?.command === "return") return cbReturnInfo
        if (cbReturnInfo?.command === "continue") continue
      }
    }
  }
  each(tree, 1)
}

export function findTree<T>(tree: T[], cb: (item: T) => boolean) {
  let result
  eachTree(tree, (item) => {
    const isFound = cb(item)
    if (isFound) {
      result = item
      return { command: "return" }
    }
  })
  return result
}
